import type { FeatureFlags } from "@utils/FeatureFlags/generated-flags";

import { ApiReportTemplateReportTypeChoices } from "@api/graphql/types-and-hooks";

type SelfServeFlags = Pick<
  FeatureFlags,
  "ra-self-serve-templates" | "db-self-serve-templates" | "initial-ab-self-serve-customization"
>;

interface ReportTypeFlags {
  isInitialAssessment: boolean;
  isReassessment: boolean;
}

/** Active template-creation options in the Templates dialog. IA is always available. */
export const getActiveTemplateOptions = (flags: SelfServeFlags): ApiReportTemplateReportTypeChoices[] => [
  ApiReportTemplateReportTypeChoices.InitialAssessment,
  ...(flags["ra-self-serve-templates"] ? [ApiReportTemplateReportTypeChoices.Reassessment] : []),
  ...(flags["db-self-serve-templates"] ? [ApiReportTemplateReportTypeChoices.DiagnosisEvaluation] : []),
];

/**
 * Whether ReviewAndSign should render the legacy ReportSettings block.
 * IA self-serve is unconditional (no flag gate), so IA never shows the legacy UI;
 * RA / DE use their respective split flags.
 */
export const shouldShowLegacyReportSettings = (flags: SelfServeFlags, reportType: ReportTypeFlags): boolean => {
  if (reportType.isInitialAssessment) return false;
  const flagKey = reportType.isReassessment ? "ra-self-serve-templates" : "db-self-serve-templates";
  return !flags[flagKey];
};

/** Whether the Templates route and nav item are accessible. */
export const hasTemplatesAccess = (flags: SelfServeFlags): boolean => !!flags["initial-ab-self-serve-customization"];
